import React from 'react';
import styled from 'styled-components';
import { Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Card from '../Card';

const StyledCard = styled(Card)`
  opacity: ${(props) => (props.$selected ? 1 : 0.6)};
  text-align: center;
  height: 100%;
  background-color: white;
`;

const Small = styled.p`
  font-size: 0.8rem;
`;

const SelectableCard = ({
  handleClick, selected, title, description, subdescription, image, ...props
}) => (
  <StyledCard
    onClick={handleClick}
    $selected={selected}
    selectable
    {...props}
  >
    {image && (<Image src={image} />)}
    <h3>{title}</h3>
    <p>{description}</p>
    {
      subdescription && (
        <Small>{subdescription}</Small>
      )
    }
  </StyledCard>
);

SelectableCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subdescription: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  image: PropTypes.node,
};

SelectableCard.defaultProps = {
  image: null,
  subdescription: null,
};

export default SelectableCard;
